import { Account } from '@liquidbudget/common';
import { DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { toast } from '@/components/ui/toast/use-toast';
import { AccountArchiveForm } from './account-archive-form';

interface Props {
  account: Account;
  onClose: () => void;
}

export function AccountArchiveDialog({ account, onClose }: Props) {
  const onSuccess = () => {
    onClose();
    toast({
      title: 'Success',
      description: 'Your account has been archived',
    });
  };

  return (
    <DialogContent onInteractOutside={(e) => e.preventDefault()}>
      <DialogHeader>
        <DialogTitle>Archive {account.name}</DialogTitle>
      </DialogHeader>
      <DialogDescription>
        When you no longer use an account, you can archive it to maintain your transaction history.
      </DialogDescription>
      <AccountArchiveForm account={account} onSuccess={onSuccess} />
    </DialogContent>
  );
}
